import { readMeta } from './page';

declare global {
  interface Window {
    _sift?: Array<unknown>;
  }
}

let siftAccountConfigured = false;

export function resetSiftTrackingState(): void {
  siftAccountConfigured = false;
}

export function shouldTrackSift(): boolean {
  const ssoUuid = readMeta('account', 'data-account');
  const trackSift = readMeta('track_sift');
  return Boolean(ssoUuid && trackSift);
}

export function injectSiftScript(): void {
  if (document.querySelector('#_sift')) return;

  const script = document.createElement('script');
  script.src = 'https://cdn.siftscience.com/s.js';
  script.id = '_sift';
  document.body.appendChild(script);
}

/** Queue account, user, and session once. Pageviews are sent from the router guard. */
export function initSiftAccount(): void {
  if (!shouldTrackSift() || siftAccountConfigured) return;

  const siftKey = readMeta('sift');
  const ssoUuid = readMeta('account', 'data-account');
  const sessionID = readMeta('session');
  const sift = (window._sift = window._sift || []);

  sift.push(['_setAccount', siftKey]);
  sift.push(['_setUserId', ssoUuid]);
  sift.push(['_setSessionId', sessionID]);
  siftAccountConfigured = true;
}

export function trackSiftPageview(): void {
  if (!shouldTrackSift()) return;

  initSiftAccount();
  const sift = (window._sift = window._sift || []);
  sift.push(['_trackPageview']);
}
